import React from 'react'
import { Accuracy } from './ChallengeExplainers/Accuracy'
import { FastestShot } from './ChallengeExplainers/FastestShot'
import { GoalieSkills } from './ChallengeExplainers/GoalieSkills'

type ChallengeItemProps = {
  challengeName: string
}

export const ChallengeRules: React.FC<ChallengeItemProps> = ({ challengeName }) => {
  switch (challengeName) {
    case 'accuracy':
      return <Accuracy />
    case 'fastestShot':
      return <FastestShot />
    case 'goalie':
      return <GoalieSkills />
    default:
      return <div />
  }
}
